import React, { useEffect, useState } from 'react'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTimeSlotData } from '../../../../../Redux/action/MasterAction'

import Beatloader from '../../../../../Common/BeatLoader'
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { Modal } from "react-bootstrap";
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
import { getTutorGroupCategoryData, getTutorGroupChildCategoryData, getTutorGroupSubCategoryData } from '../../../../../Redux/action/TutorAction'
import HourglassLoader from '../../../../../Common/HourglassLoader'
import GoogleMeetStatus from '../../../../../Common/GoogleMeetStatus'
const host = process.env.REACT_APP_API_SERVER

const TutorAddNewGroupCourse = () => {
    const authToken = localStorage.getItem('tutor-token');
    const decoded = jwtDecode(authToken);

    const userTimeZone = decoded?.user?.time_zone
    const todayLocal = moment().tz(userTimeZone).format("YYYY-MM-DD"); // Convert to local timezone


    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // useEffect(() => {
    //     dispatch(getBrowsStudentRequestedDetailData(requestId))
    // }, [requestId]);
    useEffect(() => {
        dispatch(getTutorGroupCategoryData());
        dispatch(getTimeSlotData(authToken));
    }, [])
    const {
        loadingTutorGroupCategoryDataListApi,
        TutorGroupCategoryDataListApiData,
        TutorGroupCategoryDataListApiError,

        loadingTutorGroupSubCategoryDataListApi,
        TutorGroupSubCategoryDataListApiData,
        TutorGroupSubCategoryDataListApiError,

        loadingTutorGroupChildCategoryDataListApi,
        TutorGroupChildCategoryDataListApiData,
        TutorGroupChildCategoryDataListApiError


    } = useSelector(state => state?.TutorReducer);

    const {

        loadingTimeSlotDataListApi,
        TimeSlotDataListApiData,
        TimeSlotDataListApiError,

    } = useSelector(state => state?.MasterReducer);

    const [sessionData, setSessionData] = useState([]);


    let [initialValues, setInitialValues] = useState({

        batch_name: "",
        teaching_type: "1",
        name: "",
        category_id: "",
        sub_category_id: "",
        child_sub_cat_id: "",
        description: "",
        batch_start_date: "",
        batch_end_date: "",
        batch_session_data: sessionData,
        firstSessionDate: "",
        firstSessionTime: "",
        firstSessionTopic: "",
        max_no_of_student: "",
        meetingProvider: "videosdk",
    })

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Course name is required"),
        category_id: Yup.string().required("Class is required"),
        sub_category_id: Yup.string().required("Subject is required"),
        child_sub_cat_id: Yup.string().required("Module is required"),
        description: Yup.string().required("Course description is required"),
        batch_start_date: Yup.date().required("Start date is required"),

        batch_end_date: Yup.date()
            .required("End date is required")
            .min(
                Yup.ref("batch_start_date"),
                "End date must be greater than or equal to start date"
            ),
        firstSessionDate: Yup.date().required("Session start date is required"),
        firstSessionTime: Yup.string().required("Session start time is required"),
        firstSessionTopic: Yup.string().required("Session topic is required"),
        batch_name: Yup.string().required("Batch name is required"),
        max_no_of_student: Yup.string().required("Max no. of student is required"),
        meetingProvider: Yup.string().required("Please select an option"),

    });



    const getSelectedTimeSlot = (timeSlotId) => {
        return TimeSlotDataListApiData?.data?.find(
            (slot) => String(slot.id) === String(timeSlotId)
        );
    };

    const getAdjustedMinEndDate = () => {
        if (!formik.values.batch_start_date || !formik.values.firstSessionTime) {
            return formik.values.batch_start_date || todayLocal;
        }

        const selectedSlot = getSelectedTimeSlot(formik.values.firstSessionTime);

        if (!selectedSlot) return formik.values.batch_start_date;

        const startTime = selectedSlot.start_time || selectedSlot.formated_start_time;
        const endTime = selectedSlot.end_time || selectedSlot.formated_end_time;

        if (!startTime || !endTime) return formik.values.batch_start_date;

        const startHour = parseInt(startTime.split(":")[0], 10);
        const endHour = parseInt(endTime.split(":")[0], 10);

        let minEndDate = moment(formik.values.batch_start_date);

        if (endHour < startHour) {
            minEndDate = minEndDate.add(1, "day");
        }

        return minEndDate.format("YYYY-MM-DD");
    };

    const formik = useFormik({
        initialValues,
        validate: (values) => {
            const errors = {};

            try {
                // Perform Yup validation
                validationSchema.validateSync(values, { abortEarly: false });
            } catch (err) {
                // Add Yup validation errors to errors object
                err.inner.forEach((validationError) => {
                    errors[validationError.path] = validationError.message;
                });
            }

            // Return early if batch_start_date or batch_end_date is missing
            if (!values.batch_start_date) {
                errors.batch_start_date = "Start date is required";
            }
            if (!values.batch_end_date) {
                errors.batch_end_date = "End date is required";
            }
            if (!values.firstSessionDate) {
                errors.firstSessionDate = "Start date is required";
            }
            if (!values.batch_start_date || !values.batch_end_date || !values.firstSessionDate) {
                return errors; // Stop further validation if required dates are missing
            }

            // Combine the first session with the batch_session_data array
            const allSessions = [
                {
                    batch_start_date: values.firstSessionDate,
                    time_slot_id: String(values.firstSessionTime), // Normalize to string
                    topic_details: values.firstSessionTopic,
                    index: "firstSession", // Unique identifier for the first session
                },
                ...(values.batch_session_data || []).map((session, index) => ({
                    ...session,
                    time_slot_id: String(session.time_slot_id), // Normalize to string
                    index,
                })),
            ];

            // Validate that all sessions have required fields
            allSessions.forEach((session) => {
                if (!session.batch_start_date) {
                    errors[
                        session.index === "firstSession"
                            ? "firstSessionDate"
                            : `batch_session_data[${session.index}].batch_start_date`
                    ] = "Session Start Date is required";
                }
                if (!session.time_slot_id) {
                    errors[
                        session.index === "firstSession"
                            ? "firstSessionTime"
                            : `batch_session_data[${session.index}].time_slot_id`
                    ] = "Session Start Time is required";
                }
                if (!session.topic_details) {
                    errors[
                        session.index === "firstSession"
                            ? "firstSessionTopic"
                            : `batch_session_data[${session.index}].topic_details`
                    ] = "Session Topic is required";
                }
            });

            // Group sessions by start date
            const groupedByDate = allSessions.reduce((acc, session) => {
                const date = session.batch_start_date;
                if (!date) {
                    console.warn(`Session is missing batch_start_date`, session);
                    return acc;
                }
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(session);
                return acc;
            }, {});

            // Validate unique time slots for the same date
            Object.entries(groupedByDate).forEach(([date, sessions]) => {
                const timeSet = new Map(); // Map to store time_slot_id and their corresponding session index
                sessions.forEach((session) => {
                    if (!session.time_slot_id) {
                        console.warn(`Session on ${date} is missing time_slot_id`, session);
                        return;
                    }
                    if (timeSet.has(session.time_slot_id)) {
                        // Assign error to the session with duplicate time_slot_id
                        const duplicateSessionIndex = session.index;
                        errors[
                            duplicateSessionIndex === "firstSession"
                                ? "firstSessionTime"
                                : `batch_session_data[${duplicateSessionIndex}].time_slot_id`
                        ] = "Start Time must be unique for the same Start Date";
                    } else {
                        timeSet.set(session.time_slot_id, session.index);
                    }
                });
            });

            // Ensure no batch_start_date exceeds the end_date or is before the start_date
            const endDate = new Date(values?.batch_end_date);
            const startDate = new Date(values?.batch_start_date);
            allSessions.forEach((session) => {
                const sessionStartDate = new Date(session.batch_start_date);
                if (sessionStartDate > endDate) {
                    errors[
                        session.index === "firstSession"
                            ? "firstSessionDate"
                            : `batch_session_data[${session.index}].batch_start_date`
                    ] = "Session Start Date cannot be after the End Date";
                }
                if (sessionStartDate < startDate) {
                    errors[
                        session.index === "firstSession"
                            ? "firstSessionDate"
                            : `batch_session_data[${session.index}].batch_start_date`
                    ] = "Session Start Date cannot be before the Start Date";
                }
            });

            return errors;
        },

        onSubmit: (values, { setSubmitting, resetForm }) => {
            try {
                const combinedSessions = [
                    {
                        batch_start_date: values.firstSessionDate,
                        time_slot_id: values.firstSessionTime,
                        topic_details: values.firstSessionTopic,
                    },
                    ...(values.batch_session_data || []),
                ];

                // Find the latest session date
                // const sessionDates = combinedSessions.map(session => new Date(session.batch_start_date));
                // const latestSessionDate = new Date(Math.max(...sessionDates)).toISOString().split('T')[0];

                const sessionDates = combinedSessions.map(session => {
                    const selectedSlot = TimeSlotDataListApiData?.data?.find(
                        slot => String(slot.id) === String(session.time_slot_id)
                    );

                    let sessionDate = moment(session.batch_start_date);

                    if (selectedSlot) {
                        const startTime = selectedSlot.start_time || selectedSlot.formated_start_time;
                        const endTime = selectedSlot.end_time || selectedSlot.formated_end_time;

                        const startMoment = moment(startTime, "HH:mm:ss");
                        const endMoment = moment(endTime, "HH:mm:ss");

                        if (endMoment.isBefore(startMoment)) {
                            sessionDate = sessionDate.add(1, "day");
                        }
                    }

                    return sessionDate;
                });

                const latestSessionDate = moment.max(sessionDates).format("YYYY-MM-DD");

                // Validate that batch_end_date matches the latest session date
                if (values.batch_end_date !== latestSessionDate) {
                    // toast.error(`The batch end date must match the date of the last session (${latestSessionDate}).`);
                    toast.error(`Last session date does not match the batch end date. Please update sessions or end date - (${latestSessionDate}).`);
                    setSubmitting(false);
                    return;
                }



                // Clear any previous errors

                values.teaching_type = '1';

                const value = {
                    ...values,
                    batch_session_data: combinedSessions,
                };

                // setSubmitting(true);
                const authToken = localStorage.getItem('tutor-token');
                let config = {
                    headers: {
                        "x-auth-token": authToken,
                    },
                };
                axios.post(`${host}/api/tutor/create-course-by-tutor-group`, value, config)
                    .then(res => {
                        if (res.status === 200) {
                            toast.success(res.data.message);
                            setSubmitting(false);
                            resetForm();
                            setShowModal(true);
                            setTimeout(() => {
                                setShowModal(false);
                                navigate('/tutor/group-course-list')
                            }, [1000])
                            // navigate('/login', { state: { user: 'student' } })
                        } else {
                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {
                        if (err.response) {
                            toast.error(err.response.data.message);
                        } else {
                            toast.error("Internal server error.");
                        }
                        setSubmitting(false);
                    });

            } catch (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Error occurred");
                setSubmitting(false);
            }
        },
    });


    // Update session data in formik and state
    const updateSessionData = (updatedSessions) => {
        setSessionData(updatedSessions);
        formik.setFieldValue("batch_session_data", updatedSessions);
    };

    // Add a new session
    const addSession = () => {
        const newSession = {
            batch_start_date: '',
            time_slot_id: '',
            topic_details: '',
        };
        updateSessionData([...sessionData, newSession]);
    };

    // Delete a session
    const deleteSession = (index) => {
        const updatedSessions = [...sessionData];
        updatedSessions.splice(index, 1);
        updateSessionData(updatedSessions);
    };




    const handleClassChange = (e) => {
        const id = e.target.value

        dispatch(getTutorGroupSubCategoryData(id))
        formik.setFieldValue('sub_category_id', '')
        formik.setFieldValue('child_sub_cat_id', '')
        if (id == '') {
            dispatch(getTutorGroupSubCategoryData('0'))
        }
        else {
            dispatch(getTutorGroupSubCategoryData(id))
        }
        dispatch(getTutorGroupChildCategoryData('0', '0'))
    }

    const handleSubjectChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('child_sub_cat_id', '')
        if (id == '') {
            dispatch(getTutorGroupChildCategoryData('0', '0'))
        }
        else {
            dispatch(getTutorGroupChildCategoryData(formik.values.category_id, id))
        }
        dispatch(getTutorGroupChildCategoryData(formik.values.category_id, id))
    }
    // useEffect(() => {

    //     dispatch(getTutorGroupSubCategoryData(formik.values.category_id));

    // }, [formik.values.category_id]);
    // useEffect(() => {

    //     dispatch(getTutorGroupChildCategoryData(formik.values.category_id, formik.values.sub_category_id));

    // }, [formik.values.category_id, formik.values.sub_category_id]);


    // useEffect(() => {
    //     if (BrowseStudentRequestedDetailApiData) {
    //         formik.setValues({
    //             tutor_id: BrowseStudentRequestedDetailApiData?.tutor_id ?? "",
    //             request_id: BrowseStudentRequestedDetailApiData?.id ?? "",
    //             category_id: BrowseStudentRequestedDetailApiData?.category ?? "",
    //             sub_category_id: BrowseStudentRequestedDetailApiData?.sub_category ?? "",
    //             child_sub_cat_id: BrowseStudentRequestedDetailApiData?.child_sub_category ?? "",
    //             start_date: BrowseStudentRequestedDetailApiData?.start_date ?? "",
    //             end_date: BrowseStudentRequestedDetailApiData?.end_date ?? "",
    //             firstSessionDate: BrowseStudentRequestedDetailApiData?.start_date ?? "",
    //             firstSessionTime: BrowseStudentRequestedDetailApiData?.time_slot_id ?? "",
    //             sessions: BrowseStudentRequestedDetailApiData?.sessions || [],
    //         });
    //     }
    // }, [BrowseStudentRequestedDetailApiData]);

    const handleStartDateChange = (e) => {

        formik.setFieldValue('firstSessionDate', e.target.value)
    }

    const handleTimeSlotChange = (e) => {

        formik.setFieldValue('firstSessionTime', e.target.value)
    }



    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Create Group Course
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="add-new-course-sec">
                                        <h4 className="mb-4">Add New Course</h4>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Select Class/Grade/General<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <select className="select-form" name='category_id' onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleClassChange(e);
                                                    }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.category_id}>
                                                        <option value=""> --Select Class--</option>
                                                        {TutorGroupCategoryDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {formik.errors.category_id && (
                                                    <div className="text-danger">
                                                        {formik.errors.category_id}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Select Subject<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <select className="select-form" name='sub_category_id' onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleSubjectChange(e)
                                                    }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.sub_category_id}>
                                                        <option value="">
                                                            --Select Subject--
                                                        </option>
                                                        {TutorGroupSubCategoryDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {formik.errors.sub_category_id && (
                                                    <div className="text-danger">
                                                        {formik.errors.sub_category_id}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Select Module<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <select className='select-form' name="child_sub_cat_id" id="city"

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.child_sub_cat_id}>
                                                        <option value="">
                                                            --Select Module--
                                                        </option>
                                                        {TutorGroupChildCategoryDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {formik.errors.child_sub_cat_id && (
                                                    <div className="text-danger">
                                                        {formik.errors.child_sub_cat_id}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Course Name <span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input
                                                        type="text"
                                                        placeholder="Please enter course name"
                                                        className="input-card-form"
                                                        name='name'

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.name}
                                                    />
                                                </div>
                                                {formik.errors.name && (
                                                    <div className="text-danger">
                                                        {formik.errors.name}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Course Description <span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input
                                                        type="text"
                                                        placeholder="Please enter course description"
                                                        className="input-card-form"
                                                        name='description'

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.description}
                                                    />
                                                </div>
                                                {formik.errors.description && (
                                                    <div className="text-danger">
                                                        {formik.errors.description}
                                                    </div>
                                                )}
                                            </div>


                                            <div className="add-new-course-sec">
                                                <h4 className="mb-4">Create New Session</h4>
                                                <div className="row my-3">
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-group">
                                                            <label htmlFor="" className="label">

                                                                Enter Batch Name<span className='text-danger'>*</span>
                                                            </label>
                                                            <br />
                                                            <input type="text" className="input-card-form" name='batch_name'

                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.batch_name}
                                                            />
                                                        </div>
                                                        {formik.errors.batch_name && (
                                                            <div className="text-danger">
                                                                {formik.errors.batch_name}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-group">
                                                            <label htmlFor="" className="label">
                                                                Max No. Of Students<span className='text-danger'>*</span>
                                                            </label>
                                                            <br />
                                                            <input type="number" className="input-card-form" name='max_no_of_student'
                                                                min={1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.max_no_of_student}
                                                            />
                                                        </div>
                                                        {formik.errors.max_no_of_student && (
                                                            <div className="text-danger">
                                                                {formik.errors.max_no_of_student}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-group">
                                                            <label htmlFor="" className="label">
                                                                Select Your Local Time Slot ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span>
                                                            </label>
                                                            <br />
                                                            <select
                                                                className="select-form"
                                                                name="time_slot_id"

                                                                onChange={(e) => { formik.handleChange(e); handleTimeSlotChange(e) }}
                                                                onBlur={formik.handleBlur}
                                                                value={`${formik.values.time_slot_id}`}

                                                            >
                                                                <option value="">-Select-</option>
                                                                {
                                                                    TimeSlotDataListApiData?.data?.map((data) => (
                                                                        <option value={`${data?.id}`}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                        {formik.errors.time_slot_id && (
                                                            <div className="text-danger">
                                                                {formik.errors.time_slot_id}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-group">
                                                            <label htmlFor="" className="label">
                                                                Start Date<span className='text-danger'>*</span>
                                                            </label>
                                                            <br />
                                                            <input
                                                                min={todayLocal}
                                                                type="date" name='batch_start_date'
                                                                onChange={(e) => { formik.handleChange(e); handleStartDateChange(e) }}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.batch_start_date} className="input-card-form" />
                                                        </div>
                                                        {formik.errors.batch_start_date && (
                                                            <div className="text-danger">
                                                                {formik.errors.batch_start_date}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-group">
                                                            <label htmlFor="" className="label">
                                                                End Date<span className='text-danger'>*</span>
                                                            </label>
                                                            <br />
                                                            <input type="date" className="input-card-form" name='batch_end_date'
                                                                // min={formik.values.batch_start_date}
                                                                min={getAdjustedMinEndDate()}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.batch_end_date} />
                                                        </div>
                                                        {formik.errors.batch_end_date && (
                                                            <div className="text-danger">
                                                                {formik.errors.batch_end_date}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* Meeting Provider Selection */}
                                                    <div className="row my-3">
                                                        <div className="col-lg-6 col-md-6">
                                                            <label className="form-label fw-semibold">
                                                                Schedule your session use <span className="text-danger">*</span>
                                                            </label>

                                                            <div className="d-flex gap-4">
                                                                {/* VideoSDK */}
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="meetingProvider"
                                                                        id="videosdk"
                                                                        value="videosdk"
                                                                        checked={formik.values.meetingProvider === "videosdk"}
                                                                        onChange={formik.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="videosdk">
                                                                        via Seek2lrn
                                                                    </label>
                                                                </div>

                                                                {/* Google Meet */}
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="meetingProvider"
                                                                        id="gmeet"
                                                                        value="gmeet"
                                                                        checked={formik.values.meetingProvider === "gmeet"}
                                                                        onChange={formik.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="gmeet">
                                                                        via Google Meet
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {formik.errors.meetingProvider && (
                                                                <div className="text-danger mt-1">{formik.errors.meetingProvider}</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* If Google Meet is selected, check Gmail availability */}
                                                    {formik.values.meetingProvider === "gmeet" && (
                                                        <GoogleMeetStatus />
                                                    )}
                                                </div>

                                                <div className="card bg-light height-auto">
                                                    <div className="card-body">
                                                        <div id="session-container">

                                                            <div

                                                                className="session mb-4"

                                                            >
                                                                <div className="row">
                                                                    <div className="col-lg-10">
                                                                        <h6 className="mb-3">Session-1</h6>
                                                                    </div>
                                                                    {/* Session Start Date */}
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <div className="input-group">
                                                                            <label className="label">Session Start Date<span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <input
                                                                                min={todayLocal}
                                                                                type="date"
                                                                                className="input-card-form"
                                                                                name="firstSessionDate" id="city"
                                                                                readOnly
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.firstSessionDate}

                                                                            />

                                                                        </div>
                                                                        {formik.errors.firstSessionDate && (
                                                                            <div className="text-danger">
                                                                                {formik.errors.firstSessionDate}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* Session Start Time */}
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <div className="input-group">
                                                                            <label className="label">Session Start Time ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <select
                                                                                className="select-form"
                                                                                name="firstSessionTime" id="city"
                                                                                disabled
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={`${formik.values.firstSessionTime}`}

                                                                            >
                                                                                <option value="">-Select-</option>
                                                                                {
                                                                                    TimeSlotDataListApiData?.data?.map((data) => (
                                                                                        <option value={`${data?.id}`}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                                                    ))}
                                                                            </select>

                                                                        </div>
                                                                        {formik.errors.firstSessionTime && (
                                                                            <div className="text-danger">
                                                                                {formik.errors.firstSessionTime}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* Enter Topic Details */}
                                                                    <div className="col-lg-12">
                                                                        <div className="input-group">
                                                                            <label className="label">Enter Topic Details<span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <textarea
                                                                                className="input-card-form"
                                                                                name="firstSessionTopic" id="city"

                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.firstSessionTopic}
                                                                            />

                                                                        </div>
                                                                        {formik.errors.firstSessionTopic && (
                                                                            <div className="text-danger">
                                                                                {formik.errors.firstSessionTopic}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {sessionData.map((session, index) => (
                                                                <div key={index} className="session mb-4">
                                                                    <div className="row">
                                                                        <div className="col-lg-10">
                                                                            <h6 className="mb-3">Session-{index + 2}</h6>
                                                                        </div>
                                                                        <div className="col-lg-2 d-flex justify-content-end">

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger px-2 py-1"
                                                                                onClick={() => deleteSession(index)}
                                                                            >
                                                                                <i className="fa-solid fa-trash"></i>
                                                                            </button>

                                                                        </div>

                                                                        {/* Session Start Date */}
                                                                        <div className="col-lg-6 col-md-6">
                                                                            <div className="input-group">
                                                                                <label className="label">Session Start Date<span className='text-danger'>*</span></label>
                                                                                <br />
                                                                                <input
                                                                                    min={formik.values.batch_start_date}
                                                                                    max={formik.values.batch_end_date}
                                                                                    type="date"
                                                                                    className="input-card-form"
                                                                                    name={`batch_session_data[${index}].batch_start_date`}
                                                                                    value={session.batch_start_date}
                                                                                    onChange={(e) => {
                                                                                        const updatedSessions = [...sessionData];
                                                                                        updatedSessions[index].batch_start_date =
                                                                                            e.target.value;
                                                                                        updateSessionData(updatedSessions);
                                                                                    }}
                                                                                    required
                                                                                />
                                                                                {formik.errors[`batch_session_data[${index}].batch_start_date`] && (
                                                                                    <div className="text-danger">
                                                                                        {formik.errors[`batch_session_data[${index}].batch_start_date`]}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        {/* Session Start Time */}
                                                                        <div className="col-lg-6 col-md-6">
                                                                            <div className="input-group">
                                                                                <label className="label">Session Start Time ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span></label>
                                                                                <br />
                                                                                <select

                                                                                    className="select-form"
                                                                                    name={`batch_session_data[${index}].time_slot_id`}
                                                                                    value={session.time_slot_id}
                                                                                    onChange={(e) => {
                                                                                        const updatedSessions = [...sessionData];
                                                                                        updatedSessions[index].time_slot_id = e.target.value;
                                                                                        updateSessionData(updatedSessions);
                                                                                    }}
                                                                                    required
                                                                                >
                                                                                    <option value="">-Select-</option>
                                                                                    {/* Replace with your actual time slot data */}
                                                                                    {
                                                                                        TimeSlotDataListApiData?.data?.map((data) => (
                                                                                            <option value={data?.id}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                                                        ))}
                                                                                </select>
                                                                                {formik.errors[`batch_session_data[${index}].time_slot_id`] && (
                                                                                    <div className="text-danger">
                                                                                        {formik.errors[`batch_session_data[${index}].time_slot_id`]}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        {/* Topic Details */}
                                                                        <div className="col-lg-12">
                                                                            <div className="input-group">
                                                                                <label className="label">Enter Topic Details<span className='text-danger'>*</span></label>
                                                                                <br />
                                                                                <textarea
                                                                                    className="input-card-form"
                                                                                    name={`batch_session_data[${index}].topic_details`}
                                                                                    placeholder="Topic Details"
                                                                                    value={session.topic_details}
                                                                                    onChange={(e) => {
                                                                                        const updatedSessions = [...sessionData];
                                                                                        updatedSessions[index].topic_details = e.target.value;
                                                                                        updateSessionData(updatedSessions);
                                                                                    }}
                                                                                    required
                                                                                />
                                                                                {formik.errors[`batch_session_data[${index}].topic_details`] && (
                                                                                    <div className="text-danger">
                                                                                        {formik.errors[`batch_session_data[${index}].topic_details`]}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}


                                                            {/* Add Session Button at the End of Last Session */}
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary px-2 py-1 add-session-btn"
                                                                    onClick={addSession}
                                                                >
                                                                    <i className="fa-solid fa-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <h6 className="text-primary mb-0 mt-4">
                                                    Total Session&nbsp;
                                                    <p
                                                        className="fw-bold btn btn-primary mb-0"
                                                        style={{ borderRadius: "50%", fontSize: 12, padding: "5px 10px" }}
                                                    >
                                                        {sessionData?.length + 1}
                                                    </p>
                                                </h6>
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-12">

                                                        <button
                                                            type="submit"
                                                            disabled={formik.isSubmitting}
                                                            className="btn btn-primary fw-bold w-100 mb-4 mt-2"
                                                        >
                                                            {formik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* <div className="row">
                                        <div className="col-lg-4 col-md-12">
                                            <Link to="/tutor/create-new-session-group">
                                                <input
                                                    type="submit"
                                                    defaultValue="Create Course "
                                                    className="btn btn-primary w-100 mt-3"
                                                />
                                            </Link>
                                        </div>
                                    </div> */}
                                    </div>
                                </form>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* Modal */}
                <Modal className='modal' show={showModal} onHide={() => setShowModal(false)}

                >

                    {/* <div className="modal-content text-center"> */}
                    <Modal.Body className='text-center'>
                        <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                        <h4 className='text-center'>
                            We will reach you after getting approval from{" "}
                            <span className="text-primary">Admin</span>
                        </h4>
                        <Link to="/tutor/dashboard">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-primary mt-4 px-4 mb-5">
                                Okay
                            </button>
                        </Link>
                    </Modal.Body>
                    {/* </div> */}

                </Modal>
            </>


        </div>
    )
}

export default TutorAddNewGroupCourse